import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Tags, 
  Users, 
  Building2, 
  ShoppingCart, 
  History,
  Building,
  FileText,
  Truck, 
  Package,
  Receipt,
  Tag,
  LogOut
} from 'lucide-react';
import logoImg from '../assets/logo_alefolia_alpha.png';
import './Sidebar.css';

const navItems = [
  { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { path: '/categorias', label: 'Categorias', icon: Tags },
  { path: '/clientes', label: 'Clientes', icon: Users },
  { path: '/centro-custos', label: 'Centro de Custos', icon: Building2 },
  { path: '/pedidos', label: 'Pedidos de Venda', icon: ShoppingCart },
  { path: '/orcamentos-retroativos', label: 'Orçamentos Retroativos', icon: History },
  { path: '/fornecedores', label: 'Fornecedores', icon: Building },
  { path: '/notas-fornecedores', label: 'Notas Fornecedores', icon: FileText },
  { path: '/transportadoras', label: 'Transportadoras', icon: Truck },
  { path: '/tabelas', label: 'Tabelas', icon: Tag },
  { path: '/estoque', label: 'Estoque', icon: Package },
  { path: '/despesas', label: 'Despesas', icon: Receipt },
];

export default function Sidebar({ isOpen }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('userId');
    navigate('/login');
  };

  return (
    <aside className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-header">
        <div className="logo-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', overflow: 'hidden' }}>
          <img 
            src={logoImg} 
            alt="Alefolia Logo" 
            style={{ 
              height: isOpen ? '46px' : '36px', 
              maxWidth: isOpen ? '170px' : '36px', 
              objectFit: 'contain',
              transition: 'all 0.2s ease-in-out'
            }} 
          />
        </div>
      </div>
      
      <nav className="sidebar-nav">
        <div className="nav-section-title">{isOpen ? 'MENU PRINCIPAL' : '•••'}</div>
        <ul>
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <li key={item.path}>
                <NavLink 
                  to={item.path} 
                  className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                  title={!isOpen ? item.label : undefined}
                >
                  <Icon className="nav-icon" size={20} />
                  {isOpen && <span className="nav-label">{item.label}</span>}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
      
      <div className="sidebar-footer">
        <button onClick={handleLogout} className="nav-link logout-link" style={{ width: '100%', background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit' }}>
          <LogOut className="nav-icon" size={20} />
          {isOpen && <span className="nav-label">Sair</span>}
        </button>
      </div>
    </aside>
  );
}
